module.exports = __webpack_public_path__ + "img/5.cc8f15bb.jpg";